// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7069fa99","732":"2f0f473d","977":"e32e6e00"}[chunkId] + ".chunk.js";
};